(function () {
  var BP_SP_MAX = 749;
  var BP_PC_MIN = 990;

  var q = function (selector, context) {
    return (context || document).querySelector(selector);
  };

  var esc = function (value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (match) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[match];
    });
  };

  var truncate = function (value, length) {
    var text = String(value == null ? '' : value);
    if (text.length <= length) return text;
    return text.slice(0, Math.max(0, length - 3)) + '...';
  };

  var isNew = function (publishedAt) {
    if (!publishedAt) return false;
    var published = new Date(publishedAt).getTime();
    if (Number.isNaN(published)) return false;
    var elapsedDays = (Date.now() - published) / (1000 * 60 * 60 * 24);
    return elapsedDays >= 0 && elapsedDays < 30;
  };

  var perPageFor = function (root) {
    var width = window.innerWidth;
    if (width >= BP_PC_MIN) return Number(root.dataset.perPagePc) || 35;
    if (width <= BP_SP_MAX) return Number(root.dataset.perPageSp) || 36;
    return Number(root.dataset.perPageTb) || 36;
  };

  var normalize = function (value) {
    return String(value == null ? '' : value).toLowerCase();
  };

  var parseData = function (scriptEl) {
    if (!scriptEl) return [];
    try {
      var parsed = JSON.parse(scriptEl.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  var fetchPage = function (url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.text() : Promise.reject(response.status);
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return parseData(doc.querySelector('[data-aw-style-list-data]'));
      })
      .catch(function () {
        return [];
      });
  };

  var cardHtml = function (item, favoriteIcons) {
    var media = '<img class="aw-style-card__image" src="' + esc(item.image) + '" width="' + (item.imageWidth || '') + '" height="' + (item.imageHeight || '') + '" loading="lazy" alt="' + esc(item.imageAlt || item.title) + '">';
    var badge = isNew(item.publishedAt) ? '<span class="aw-style-card__new">NEW</span>' : '';
    var length = item.length ? '<p class="aw-style-card__length">' + esc(item.length) + '</p>' : '';
    var favoriteIconsHtml = '<span class="aw-style-card__favorite-icon aw-style-card__favorite-icon--outline">' + (favoriteIcons.outline || '') + '</span>' +
      '<span class="aw-style-card__favorite-icon aw-style-card__favorite-icon--fill">' + (favoriteIcons.fill || '') + '</span>';
    var favorite = item.handle
      ? '<button type="button" class="aw-style-card__favorite" data-aw-favorite-button data-favorite-type="style" data-favorite-handle="' + esc(item.handle) + '" data-favorite-url="' + esc(item.url) + '" data-favorite-title="' + esc(item.title) + '" data-favorite-image="' + esc(item.image) + '" data-favorite-image-alt="' + esc(item.imageAlt || item.title) + '" data-favorite-meta="' + esc(item.length) + '" aria-pressed="false" aria-label="お気に入りに追加">' + favoriteIconsHtml + '</button>'
      : '';
    var topRow = (length || favorite) ? '<div class="aw-style-card__top-row">' + length + favorite + '</div>' : '';
    var title = item.title ? '<h3 class="aw-style-card__title">' + esc(item.title) + '</h3>' : '';
    var excerpt = item.stylePoint ? '<p class="aw-style-card__excerpt">' + esc(truncate(item.stylePoint, 42)) + '</p>' : '';
    var salon = item.salon ? '<p class="aw-style-card__salon">' + esc(item.salon) + '</p>' : '';
    var staff = item.staff ? '<p class="aw-style-card__staff">' + esc(item.staff) + '</p>' : '';
    var meta = (salon || staff) ? '<div class="aw-style-card__meta">' + salon + staff + '</div>' : '';
    var body = '<div class="aw-style-card__body">' + topRow + title + excerpt + meta + '</div>';
    var tag = item.url ? 'a' : 'div';
    var href = item.url ? ' href="' + esc(item.url) + '"' : '';
    var linkClass = item.url ? ' aw-link-hover' : '';

    return '<' + tag + ' class="aw-style-card' + linkClass + '"' + href + '>' +
      '<div class="aw-style-card__image-wrap">' + media + badge + '</div>' +
      body +
      '</' + tag + '>';
  };

  function initStyleList(root) {
    var grid = q('[data-aw-style-list-grid]', root);
    var pagination = q('[data-aw-style-list-pagination]', root);
    var countEl = q('[data-aw-style-list-count]', root);
    var loading = q('[data-aw-style-list-loading]', root);
    if (!grid) return;

    var items = parseData(q('[data-aw-style-list-data]', root));
    var totalPages = Number(root.dataset.sourcePages || 1);
    var pageParam = root.dataset.sourcePageParam || 'page';
    var sortBy = root.dataset.sortBy === 'published_at' ? 'published_at' : 'display_order';
    var favoriteIcons = {
      outline: root.dataset.favoriteIconSvg || '',
      fill: root.dataset.favoriteIconFillSvg || ''
    };
    var activeTab = 'all';
    var currentPageByTab = { all: 1, favorites: 1 };

    var searchPanel = q('[data-aw-style-search]');
    var activeLengths = [];
    var activeColors = [];
    var activeKeyword = '';

    var scopeParams = new URL(window.location.href).searchParams;
    var scopeStaff = scopeParams.get('staff') || '';
    var scopeBrand = scopeParams.get('brand') || '';
    var scopeSalon = scopeParams.get('salon') || '';
    var KNOWN_LENGTHS = ['ショート', 'ボブ', 'ミディアム', 'ロング', 'ミセス'];
    var KNOWN_COLORS = ['ブラウン', 'ベージュ', 'レッド', 'ピンク', 'ラベンダー', 'アッシュ', 'グレージュ', '暗髪', 'ハイトーン', 'ハイライト', '白髪ぼかし'];

    var colorsOf = function (item) {
      return (item.colors || [])
        .map(function (value) { return String(value == null ? '' : value).trim(); })
        .filter(function (value) { return !!value; });
    };

    var matchesFilters = function (item) {
      if (scopeStaff && item.staffHandle !== scopeStaff) return false;
      if (scopeBrand && item.brandHandle !== scopeBrand) return false;
      if (scopeSalon && item.salonHandle !== scopeSalon) return false;
      if (activeLengths.length && activeLengths.indexOf(item.length) === -1) return false;
      if (activeColors.length) {
        var itemColors = colorsOf(item);
        var hit = activeColors.some(function (selected) { return itemColors.indexOf(selected) !== -1; });
        if (!hit) return false;
      }
      if (activeKeyword !== '') {
        var keywordHaystack = [item.title, item.stylePoint, item.colorPoint, item.carePoint, item.salon, item.staff]
          .map(normalize)
          .join(' ');
        if (keywordHaystack.indexOf(normalize(activeKeyword)) === -1) return false;
      }
      if (activeTab === 'favorites') {
        if (!window.awFavorites || !window.awFavorites.isFavorite('style', item.handle)) return false;
      }
      return true;
    };

    var sortItems = function () {
      if (sortBy === 'published_at') {
        items.sort(function (a, b) {
          var aTime = a.publishedAt ? new Date(a.publishedAt).getTime() : 0;
          var bTime = b.publishedAt ? new Date(b.publishedAt).getTime() : 0;
          if (Number.isNaN(aTime)) aTime = 0;
          if (Number.isNaN(bTime)) bTime = 0;
          return bTime - aTime;
        });
        return;
      }
      items.sort(function (a, b) {
        return Number(a.displayOrder || 999999) - Number(b.displayOrder || 999999);
      });
    };

    var render = function () {
      var perPage = perPageFor(root);
      var visible = items.filter(function (item) {
        return !!item.image && matchesFilters(item);
      });
      var maxPage = Math.max(1, Math.ceil(visible.length / perPage));
      if (currentPageByTab[activeTab] > maxPage) currentPageByTab[activeTab] = maxPage;
      var currentPage = currentPageByTab[activeTab];

      if (countEl) countEl.textContent = String(visible.length);

      var start = (currentPage - 1) * perPage;
      var pageItems = visible.slice(start, start + perPage);

      var emptyMessage = activeTab === 'favorites'
        ? 'お気に入りに登録されたスタイルがありません。'
        : '該当するスタイルがありません。';

      grid.innerHTML = pageItems.length
        ? pageItems.map(function (item) { return cardHtml(item, favoriteIcons); }).join('')
        : '<p class="aw-style-list__empty">' + emptyMessage + '</p>';

      if (window.awFavorites) window.awFavorites.init(grid);

      renderPagination(maxPage, currentPage);
      saveState();
    };

    var goToPage = function (page) {
      currentPageByTab[activeTab] = page;
      render();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    var renderPagination = function (maxPage, currentPage) {
      if (!pagination) return;
      pagination.innerHTML = '';
      if (maxPage <= 1) return;

      var addButton = function (label, page, isActive, isDisabled) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'aw-style-list__page' + (isActive ? ' aw-style-list__page--active' : '');
        button.textContent = label;
        button.disabled = !!isDisabled;
        button.setAttribute('aria-current', isActive ? 'page' : 'false');
        button.addEventListener('click', function () {
          goToPage(page);
        });
        pagination.appendChild(button);
      };

      addButton('‹', Math.max(1, currentPage - 1), false, currentPage === 1);

      var from = Math.max(1, currentPage - 2);
      var to = Math.min(maxPage, from + 4);
      from = Math.max(1, Math.min(from, to - 4));

      for (var page = from; page <= to; page++) {
        addButton(String(page), page, page === currentPage, false);
      }

      addButton('›', Math.min(maxPage, currentPage + 1), false, currentPage === maxPage);
    };

    var tabButtons = [];

    var setActiveTab = function (tab) {
      activeTab = tab;
      tabButtons.forEach(function (btn) {
        var isActive = btn.dataset.awStyleListTab === tab;
        btn.classList.toggle('aw-style-list__tab--active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    };

    var initTabs = function () {
      tabButtons = Array.prototype.slice.call(root.querySelectorAll('[data-aw-style-list-tab]'));
      tabButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var tab = button.dataset.awStyleListTab;
          if (tab === activeTab) return;
          setActiveTab(tab);
          render();
        });
      });
    };

    var syncToggles = function (buttons, selectedValues, valueKey) {
      buttons.forEach(function (button) {
        var value = button.dataset[valueKey];
        var isActive = value === 'all' ? selectedValues.length === 0 : selectedValues.indexOf(value) !== -1;
        button.classList.toggle('aw-search-panel__toggle--active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    };

    var toggleValue = function (selectedValues, value) {
      if (!value || value === 'all') return [];
      var index = selectedValues.indexOf(value);
      if (index === -1) return selectedValues.concat(value);
      return selectedValues.filter(function (selected) { return selected !== value; });
    };

    var bindToggleButton = function (button, selector, valueKey, getSelected, setSelected) {
      button.addEventListener('click', function () {
        setSelected(toggleValue(getSelected(), button.dataset[valueKey]));
        var allButtons = Array.prototype.slice.call(searchPanel.querySelectorAll(selector));
        syncToggles(allButtons, getSelected(), valueKey);
        currentPageByTab[activeTab] = 1;
        render();
      });
    };

    var initToggleGroup = function (selector, valueKey, getSelected, setSelected) {
      var buttons = Array.prototype.slice.call(searchPanel.querySelectorAll(selector));
      buttons.forEach(function (button) {
        bindToggleButton(button, selector, valueKey, getSelected, setSelected);
      });
    };

    var addDynamicOptions = function (config) {
      if (!searchPanel) return;
      var group = searchPanel.querySelector(config.groupSelector);
      if (!group) return;

      var seen = {};
      var extras = [];
      items.forEach(function (item) {
        config.getValues(item).forEach(function (value) {
          if (!value || config.known.indexOf(value) !== -1 || seen[value]) return;
          seen[value] = true;
          extras.push(value);
        });
      });

      extras.forEach(function (value) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'aw-search-panel__toggle';
        button.dataset[config.valueKey] = value;
        button.setAttribute('aria-pressed', 'false');
        button.textContent = value;
        group.appendChild(button);
        bindToggleButton(button, config.selector, config.valueKey, config.getSelected, config.setSelected);
      });
    };

    var addDynamicLengthOptions = function () {
      addDynamicOptions({
        groupSelector: '[data-aw-style-length-group]',
        getValues: function (item) { return [item.length]; },
        known: KNOWN_LENGTHS,
        selector: '[data-style-length]',
        valueKey: 'styleLength',
        getSelected: function () { return activeLengths; },
        setSelected: function (values) { activeLengths = values; }
      });
    };

    var addDynamicColorOptions = function () {
      addDynamicOptions({
        groupSelector: '[data-aw-style-color-group]',
        getValues: colorsOf,
        known: KNOWN_COLORS,
        selector: '[data-style-color]',
        valueKey: 'styleColor',
        getSelected: function () { return activeColors; },
        setSelected: function (values) { activeColors = values; }
      });
    };

    var initSearchPanel = function () {
      if (!searchPanel) return;

      initToggleGroup('[data-style-length]', 'styleLength',
        function () { return activeLengths; },
        function (values) { activeLengths = values; });

      initToggleGroup('[data-style-color]', 'styleColor',
        function () { return activeColors; },
        function (values) { activeColors = values; });

      var applyKeyword = function (keyword) {
        activeKeyword = String(keyword || '').trim();
        var input = searchPanel.querySelector('.aw-search-panel__search-input');
        if (input) input.value = activeKeyword;
        currentPageByTab[activeTab] = 1;
        render();
      };

      var searchForm = searchPanel.querySelector('.aw-search-panel__search');
      if (searchForm) {
        searchForm.addEventListener('submit', function (event) {
          event.preventDefault();
          var input = searchForm.querySelector('.aw-search-panel__search-input');
          applyKeyword(input ? input.value : '');
        });
      }

      var keywordLinks = Array.prototype.slice.call(searchPanel.querySelectorAll('.aw-search-panel__keyword'));
      keywordLinks.forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          var url = new URL(link.href, window.location.href);
          applyKeyword(url.searchParams.get('keyword'));
        });
      });

      var initialKeyword = new URL(window.location.href).searchParams.get('keyword');
      if (initialKeyword) applyKeyword(initialKeyword);
    };

    var showScope = function () {
      var scopeEl = q('[data-aw-style-list-scope]', root);
      var labelEl = scopeEl ? q('[data-aw-style-list-scope-label]', scopeEl) : null;
      if (!scopeEl || !labelEl || (!scopeStaff && !scopeBrand && !scopeSalon)) return;

      var names = [];
      if (scopeSalon) {
        var salonItem = items.filter(function (item) { return item.salonHandle === scopeSalon; })[0];
        if (salonItem && salonItem.salon) names.push(salonItem.salon);
      }
      if (scopeStaff) {
        var staffItem = items.filter(function (item) { return item.staffHandle === scopeStaff; })[0];
        if (staffItem && staffItem.staff) names.push(staffItem.staff);
      }
      if (scopeBrand) {
        var brandItem = items.filter(function (item) { return item.brandHandle === scopeBrand; })[0];
        if (brandItem && brandItem.brand) names.push(brandItem.brand);
      }
      labelEl.textContent = '「' + (names.join('・') || '指定の条件') + '」で絞り込み中';
      scopeEl.hidden = false;
    };

    var ENTRY_KEY = '__awStyleListEntry';
    var entryToken = function () {
      try {
        var previous = window.history.state;
        var state = previous && typeof previous === 'object' ? previous : {};
        if (state[ENTRY_KEY]) return state[ENTRY_KEY];
        var token = String(Date.now()) + '-' + String(Math.random()).slice(2);
        var replacement = {};
        Object.keys(state).forEach(function (key) { replacement[key] = state[key]; });
        replacement[ENTRY_KEY] = token;
        window.history.replaceState(replacement, '');
        return token;
      } catch (error) { return null; }
    };
    var restoreScroll = function (value) {
      var y = Number(value);
      if (!Number.isFinite(y) || y <= 0) return;
      var cancelled = false;
      var cancel = function () { cancelled = true; };
      window.addEventListener('touchstart', cancel, { passive: true });
      window.addEventListener('wheel', cancel, { passive: true });
      var apply = function () {
        if (cancelled) return;
        var html = document.documentElement;
        var previous = html.style.scrollBehavior;
        html.style.scrollBehavior = 'auto';
        window.scrollTo(0, y);
        html.style.scrollBehavior = previous;
      };
      window.requestAnimationFrame(apply);
      window.setTimeout(apply, 100);
      window.setTimeout(apply, 350);
      window.setTimeout(function () {
        window.removeEventListener('touchstart', cancel);
        window.removeEventListener('wheel', cancel);
      }, 450);
    };

    var STATE_KEY = 'aw-style-list-state';
    var scopeKey = [scopeStaff, scopeBrand, scopeSalon].join('|');
    var stateReady = false;

    var isBackForward = function () {
      try {
        var nav = window.performance.getEntriesByType('navigation')[0];
        if (nav) return nav.type === 'back_forward';
        return !!window.performance.navigation && window.performance.navigation.type === 2;
      } catch (error) {
        return false;
      }
    };

    var cameFromDetail = function () {
      try {
        if (!document.referrer) return false;
        var ref = new URL(document.referrer);
        if (ref.origin !== window.location.origin) return false;
        return items.some(function (item) { return item.url && item.url === ref.pathname; });
      } catch (error) {
        return false;
      }
    };

    var readState = function () {
      try {
        var parsed = JSON.parse(window.sessionStorage.getItem(STATE_KEY) || 'null');
        return parsed && typeof parsed === 'object' ? parsed : null;
      } catch (error) {
        return null;
      }
    };

    var saveState = function () {
      if (!stateReady) return;
      try {
        window.sessionStorage.setItem(STATE_KEY, JSON.stringify({
          scope: scopeKey,
          entryToken: entryToken(),
          lengths: activeLengths,
          colors: activeColors,
          keyword: activeKeyword,
          tab: activeTab,
          pages: currentPageByTab,
          y: Math.round(window.pageYOffset || 0)
        }));
      } catch (error) {
      }
    };

    var restorableValues = function (saved, selector, valueKey) {
      if (!Array.isArray(saved) || !searchPanel) return [];
      var available = Array.prototype.map.call(searchPanel.querySelectorAll(selector), function (button) {
        return button.dataset[valueKey];
      });
      return saved.filter(function (value) { return available.indexOf(value) !== -1 && value !== 'all'; });
    };

    var restoreState = function () {
      var saved = readState();
      var backForward = isBackForward();
      var touched = activeLengths.length || activeColors.length || activeKeyword !== '';
      var sameEntry = !!(saved && saved.entryToken && saved.entryToken === entryToken());
      if (!saved || saved.scope !== scopeKey || touched || !(backForward || sameEntry || cameFromDetail())) return null;

      activeLengths = restorableValues(saved.lengths, '[data-style-length]', 'styleLength');
      activeColors = restorableValues(saved.colors, '[data-style-color]', 'styleColor');
      activeKeyword = typeof saved.keyword === 'string' ? saved.keyword.trim() : '';

      if (searchPanel) {
        syncToggles(Array.prototype.slice.call(searchPanel.querySelectorAll('[data-style-length]')), activeLengths, 'styleLength');
        syncToggles(Array.prototype.slice.call(searchPanel.querySelectorAll('[data-style-color]')), activeColors, 'styleColor');
        var input = searchPanel.querySelector('.aw-search-panel__search-input');
        if (input) input.value = activeKeyword;
      }

      if (saved.tab === 'favorites' || saved.tab === 'all') setActiveTab(saved.tab);
      if (saved.pages && typeof saved.pages === 'object') {
        ['all', 'favorites'].forEach(function (tab) {
          var page = Number(saved.pages[tab]);
          if (page >= 1) currentPageByTab[tab] = Math.floor(page);
        });
      }

      return { scrollY: Number(saved.y) || 0 };
    };

    window.addEventListener('pagehide', saveState);
    grid.addEventListener('click', function (event) {
      if (event.target.closest('a.aw-style-card[href]')) saveState();
    }, true);
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      var saved = readState();
      if (saved && saved.scope === scopeKey && saved.entryToken && saved.entryToken === entryToken()) {
        restoreScroll(saved.y);
      }
    });

    var initialSaved = readState();
    if (initialSaved && (isBackForward() || (initialSaved.entryToken && initialSaved.entryToken === entryToken())) && 'scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    initTabs();
    initSearchPanel();

    document.addEventListener('aw:favorites-changed', render);
    window.addEventListener('storage', function (event) {
      if (event.key === 'aw-favorites') render();
    });

    var loadRemainingPages = function () {
      if (totalPages <= 1) return Promise.resolve();
      var base = new URL(window.location.href);
      base.searchParams.delete(pageParam);
      var jobs = [];
      for (var page = 2; page <= totalPages; page++) {
        var pageUrl = new URL(base);
        pageUrl.searchParams.set(pageParam, page);
        jobs.push(fetchPage(pageUrl.toString()));
      }
      return Promise.all(jobs).then(function (pages) {
        pages.forEach(function (pageItems) {
          items = items.concat(pageItems);
        });
      });
    };

    loadRemainingPages().then(function () {
      var seen = {};
      items = items.filter(function (item) {
        var handle = item.handle || '';
        if (handle && seen[handle]) return false;
        if (handle) seen[handle] = true;
        return true;
      });
      sortItems();
      addDynamicLengthOptions();
      addDynamicColorOptions();
      showScope();
      if (loading) loading.remove();

      var restored = restoreState();
      stateReady = true;
      render();
      if (restored) restoreScroll(restored.scrollY);
      if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'auto';
    });

    var lastPerPage = perPageFor(root);
    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        var perPage = perPageFor(root);
        if (perPage !== lastPerPage) {
          lastPerPage = perPage;
          currentPageByTab[activeTab] = 1;
        }
        render();
      }, 200);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-aw-style-list]'), initStyleList);
  });
})();
